import { useEffect, useState } from "react";

const pad = (n) => String(n).padStart(2, "0");

export const useCountdown = (iso) => {
  const [left, setLeft] = useState(() => (iso ? new Date(iso) - Date.now() : 0));
  useEffect(() => {
    if (!iso) {
      return undefined;
    }
    const t = setInterval(() => setLeft(new Date(iso) - Date.now()), 1000);
    return () => clearInterval(t);
  }, [iso]);
  return Math.max(0, left);
};

export const Countdown = ({ endsAt, className = "", testId = "countdown" }) => {
  const left = useCountdown(endsAt);
  if (!left) return <span className={className} data-testid={testId}>Finalizada</span>;
  const s = Math.floor(left / 1000);
  const d = Math.floor(s / 86400);
  const h = Math.floor((s % 86400) / 3600);
  const m = Math.floor((s % 3600) / 60);
  return (
    <span className={`font-mono tabular-nums ${className}`} data-testid={testId}>
      {d > 0 && `${d}d `}{pad(h)}:{pad(m)}:{pad(s % 60)}
    </span>
  );
};
